import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  getEndOfMonth,
  getStartOfMonth,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import MobileInput from "../MobileInput/MobileInput";
import { showErrorMessage } from "../Shared/Toast";

function Mover() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({});
  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);

  useEffect(() => {
    getScreenListData();
    getScreenData();
  }, []);

  function getScreenListData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/MNVMover/MNVMoverGetCompleteDataSetForForeignKeys"
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          l_oResponse[0] = [] as any;
          l_oResponse[0].push({ PID: 1, Name: "Driver" });
          l_oResponse[0].push({ PID: 2, Name: "Helper" });
          l_oResponse[0].push({ PID: 3, Name: "Both" });
          setScreenListData(l_oResponse);
        }
        // setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getScreenData() {
    setIsAnimation(true);
    axiosAuth
      .get(AppContext.APIURL + "api/MNVMover/MNVMoverGetCompleteGridData")
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false
          );

          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
          // console.log(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (!addEditObject.MNVMoverTypeID || addEditObject.MNVMoverTypeID == 0) {
      showErrorMessage("Please select Mover Type");
      IsOkay = false;
    } else if (!addEditObject.MNVBaseID || addEditObject.MNVBaseID == 0) {
      showErrorMessage("Please select Base");
      IsOkay = false;
    } else if (!addEditObject.SiteUserID || addEditObject.SiteUserID == 0) {
      showErrorMessage("Please select Site User");
      IsOkay = false;
    } else if (
      !addEditObject.EmailAddress ||
      addEditObject.EmailAddress == ""
    ) {
      showErrorMessage("Please enter Email");
      IsOkay = false;
    } else if (!addEditObject.MobileNo || addEditObject.MobileNo == "") {
      showErrorMessage("Please enter phone no");
      IsOkay = false;
    }
    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVMoverID = addEditObject.MNVMoverID;
    object.MNVMoverTypeID = addEditObject.MNVMoverTypeID;
    object.MNVBaseID = addEditObject.MNVBaseID;
    object.SiteUserID = addEditObject.SiteUserID;
    object.Name = addEditObject.Name;
    object.CNICNo = addEditObject.CNICNo;
    object.EmailAddress = addEditObject.EmailAddress;
    object.MobileNo = addEditObject.MobileNo;
    object.AddressLine1 = addEditObject.AddressLine1;
    object.AddressLine2 = "";
    object.IsActive = addEditObject.IsActive;
    object.IsContractor = addEditObject.IsContractor;
    object.VAT = addEditObject.VAT;
    object.CompanyCommission = addEditObject.CompanyCommission;
    object.Rating = addEditObject.Rating;
    object.CreatedByID = 0;
    object.LastUpdatedByID = 0;
    object.IsDeleted = false;
    object.Insurance = addEditObject.InsuranceExpiryDate;
    axiosAuth
      .post(AppContext.APIURL + "api/MNVMover/MNVMoverSave", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNew(0);
            getScreenData();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVMoverID = pid;
    axiosAuth
      .post(AppContext.APIURL + "api/MNVMover/MNVMoverDeleteRecord", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVMoverTypeName")) {
        (
          document.getElementById(
            "imgSort" + "MNVMoverTypeName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVBaseName")) {
        (
          document.getElementById("imgSort" + "MNVBaseName") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "SiteUserName")) {
        (
          document.getElementById(
            "imgSort" + "SiteUserName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Name")) {
        (
          document.getElementById("imgSort" + "Name") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  const [SelectedMobileNumber, SetSelectedMobileNumber] = useState("");
  useEffect(() => {
    if (SelectedMobileNumber != "+44-") {
      setAddEditObject((prevState: any) => ({
        ...prevState,
        MobileNo: SelectedMobileNumber,
      }));
    }
  }, [SelectedMobileNumber]);

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({});
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() => DownloadClientsDataInExcel("tblmover", "Mover")}
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tblmover">
              <thead>
                <tr>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Mover Type
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MNVMoverTypeName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("MNVMoverTypeName")
                          }
                          title={"Sort By Mover Type"}
                        >
                          <span id={"imgSort" + "MNVMoverTypeName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Base
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MNVBaseName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("MNVBaseName")}
                          title={"Sort By Base"}
                        >
                          <span id={"imgSort" + "MNVBaseName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        User
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "SiteUserName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("SiteUserName")}
                          title={"Sort By User"}
                        >
                          <span id={"imgSort" + "SiteUserName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Name
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Name")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Name")}
                          title={"Sort By Name"}
                        >
                          <span id={"imgSort" + "Name"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>Insurance Expiry</th>
                  <th>Email Address</th>
                  <th>Mobile #</th>
                  <th>Is Active</th>
                  <th>Is Contractor</th>
                  <th>Order By</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.MNVMoverTypeName}</td>
                          <td>{item.MNVBaseName}</td>
                          <td>{item.SiteUserName}</td>
                          <td>{item.Name}</td>
                          <td>{formateDate(item.InsuranceExpiryDate)}</td>
                          <td>{item.EmailAddress}</td>
                          <td>{item.MobileNo}</td>
                          <td>{item.IsActive == true ? "Yes" : "No"}</td>
                          <td>{item.IsContractor == true ? "Yes" : "No"}</td>
                          <td className="text-right">{item.Rating}</td>
                          <td>
                            <div className="flex-daj gap-10">
                              <a
                                href={"/moverrates?ID=" + item.MNVMoverID}
                                target="_blank"
                              >
                                <img
                                  src="images/link-b.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>

                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  SetSelectedMobileNumber(item.MobileNo);
                                  setAddEditObject(item);
                                  addEditObject.MobileNo = item.MobileNo;
                                  setAddEditObject((prevState: any) => ({
                                    ...prevState,
                                    MobileNo: item.MobileNo,
                                  }));
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.MNVMoverID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Mover Type:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MNVMoverTypeID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MNVMoverTypeID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Mover</option>
                  {screenListData[0] &&
                    screenListData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Base:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MNVBaseID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MNVBaseID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Base</option>
                  {screenListData[2] &&
                    screenListData[2].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Site User:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.SiteUserID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      SiteUserID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select User</option>
                  {screenListData[1] &&
                    screenListData[1].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Name:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Insurance Expiry Date:
                </span>
                <input
                  className="input-field w-100"
                  placeholder="Date"
                  type="date"
                  value={
                    addEditObject.InsuranceExpiryDate
                      ? moment(addEditObject.InsuranceExpiryDate).format(
                          "YYYY-MM-DD"
                        )
                      : ""
                  }
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      InsuranceExpiryDate: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Email:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.EmailAddress}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      EmailAddress: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Mobile #:</span>

                <MobileInput
                  SelectedMobileNumber={SelectedMobileNumber}
                  SetSelectedMobileNumber={SetSelectedMobileNumber}
                />

                {/* <input
                  className="input-field w-100"
                  value={addEditObject.MobileNo}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MobileNo: e.target.value,
                    }))
                  }
                /> */}
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Address:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.AddressLine1}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      AddressLine1: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Order By:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Rating}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Rating: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Active:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsActive}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsActive: e.target.checked,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Contractor:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsContractor}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsContractor: e.target.checked ? 1 : 0,
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default Mover;
